import { useCallback, useMemo, useState } from "react";

import * as ModelConverter from "@/components/features/_model/converter";

import * as Factory from "./factory";
import * as FormModelType from "./type";
import * as ValidationSchema from "./validation-schema";

export const useCancellationFormModel = (initInputModel: FormModelType.CancellationFormModel["InputModel"]) => {
	const defaultInputModel = useMemo(
		() =>
			Factory.Default.cancellationInputModelFactory(
				initInputModel.hotelID,
				initInputModel.defaultBasicBillingTicketID,
				initInputModel.defaultProBillingTicketID,
				initInputModel.isStopRecurringBasicBilling,
				initInputModel.isStopRecurringProBilling,
			),
		[
			initInputModel.defaultBasicBillingTicketID,
			initInputModel.defaultProBillingTicketID,
			initInputModel.hotelID,
			initInputModel.isStopRecurringBasicBilling,
			initInputModel.isStopRecurringProBilling,
		],
	);

	// InputModel の初期化
	const [currentInputModel, setCurrentInputModel] =
		useState<FormModelType.CancellationFormModel["InputModel"]>(initInputModel);

	// ViewModel の初期化
	const [viewModel, setViewModel] = useState<FormModelType.CancellationFormModel["ViewModel"]>(
		ModelConverter.inputModelToViewModelConverter<
			FormModelType.CancellationFormModel["InputModel"],
			FormModelType.ExcludeKeys,
			FormModelType.CancellationFormModel["QueryData"],
			ValidationSchema.CancellationInputZodSchemaType
		>({
			defaultInput: defaultInputModel,
			initInput: initInputModel,
			currentInput: initInputModel,
			excludeKeys: FormModelType.excludeKeys,
			zodSchema: ValidationSchema.CancellationInputZodSchema,
		}),
	);

	// ViewModel の更新
	const onSetViewModel = useCallback(
		(_viewModel: FormModelType.CancellationFormModel["ViewModel"]) => {
			const convertedInputModel = ModelConverter.viewModelToInputModelConverter(_viewModel);
			const convertedViewModel = ModelConverter.inputModelToViewModelConverter<
				FormModelType.CancellationFormModel["InputModel"],
				FormModelType.ExcludeKeys,
				FormModelType.CancellationFormModel["QueryData"],
				ValidationSchema.CancellationInputZodSchemaType
			>({
				defaultInput: defaultInputModel,
				initInput: initInputModel,
				currentInput: convertedInputModel,
				excludeKeys: FormModelType.excludeKeys,
				zodSchema: ValidationSchema.CancellationInputZodSchema,
			});
			// state の更新
			setCurrentInputModel(convertedInputModel);
			setViewModel(convertedViewModel);
		},
		[defaultInputModel, initInputModel],
	);

	return {
		inputModel: currentInputModel,
		viewModel,
		onSetViewModel,
	};
};
